import canvasUtils from '../utils';

export default {
  destroyEditor(canvas) {
    canvas.querySelectorAll('.ql-editor').forEach((editor) => {
      const children = [];
     Array.from(editor.children).forEach((child) => {
        children.push(child.cloneNode(true));
      });
      const component = editor.closest('[data-gp-text]');
      component.classList.remove('ql-container', 'ql-bubble');
      component.innerHTML = '';
      children.forEach((child) => {
        component.appendChild(child);
      });
    });
  },
  getSelectedNodes(nodes, range) {
    const lengths = [...nodes].map((node) => node.textContent.length);
    let count = -1;
    let start = false;
    let end = false;
    for (let i = 0; i < lengths.length; i++) {
      if (count + 1 <= range.index + range.length) {
        end = i;
      }
      count += lengths[i] + 1;
      if (start === false && count >= range.index) {
        start = i;
      }
    }
    const selected = [];
    for (let i = start; i <= end; i++) {
      if (nodes[i])
        selected.push(canvasUtils.getComponentIdFromClass(nodes[i]));
      else selected.push(canvasUtils.getComponentIdFromClass(nodes[0]));
    }
    return selected;
  },
};
